export const DEPRECATED_FONTS = [
  'Academy-Engraved',
  'Anton',
  'Bubblegum-Sans',
  'Bungee-Shade',
  'Caveat',
  'Covered-By-Your-Grace',
  'Handlee',
  'Indie-Flower',
  'Lucida-Handwriting',
  'Silom',
  'Special-Elite',
  'TragicMarker',
  'Impact',
  'Broadway',
  'Dancing-Script',
  'Dudu-Calligraphy',
  'Marker-Felt',
  'Rage',
  'Poppins',
  'Bangers',
];

export const IN_APP_FONTS = [
  'Montserrat',
  'Academy-Engraved',
  'Anton',
  'Bangers',
  'Baskerville-Old-Face',
  'Broadway',
  'Bubblegum-Sans',
  'Bungee-Shade',
  'Caveat',
  'Covered-By-Your-Grace',
  'Dancing-Script',
  'Dudu-Calligraphy',
  'Handlee',
  'Impact',
  'Indie-Flower',
  'Lucida-Handwriting',
  'Marker-Felt',
  'Pixel-Operator-Mono',
  'Rage',
  'Silom',
  'Special-Elite',
  'TragicMarker',
  'Poppins',
  'MarkerFelt',
  'LeagueGothic',
  'Yellowtail',
  'OstrichSans',
  'Junicode',
  'Aileron',
  'YoungSerif',
  'Shrikhand',
  'BagelFatOne',
  'PermanentMarker',
  'BebasNeue',
  'DMSerifDisplay',
  'PlayfairDisplay',
  'Raleway',
];

export const getTemplateFonts = (texts) => (
  [...new Set(texts.map(({ fontFamily }) => fontFamily))]
);

export const allFontsAreUploadedInApp = (fonts) => (
  !fonts || fonts.length === 0 || !(fonts.map(fontIsUploadedInApp).includes(false))
);
export const fontIsUploadedInApp = (font) => (
  (!!font && IN_APP_FONTS.map((f) => font.startsWith(f)).includes(true)) || font === null
);

export const fontIsDeprecated = (font) => (
  (!!font && DEPRECATED_FONTS.map((f) => font.startsWith(f)).includes(true))
);

export const someFontIsDeprecated = (fonts) => (
  fonts && fonts.length > 0 && fonts.map(fontIsDeprecated).includes(true)
);



// WEBPACK FOOTER //
// ./src/components/templates-manager/utils.js